/**
 * Messages utilisateur pour les échecs de mise à jour de statut commande (Admin).
 * Ne pas exposer stack / erreurs techniques brutes.
 */

const POIDS_COMPLEMENT_PENDING_MESSAGE =
  'Un complément de paiement (ajustement poids) est en attente. Finalisez-le avant de passer la commande en « Prête ».';

/** @deprecated Garde retirée — conservé pour messages API legacy */
const POIDS_REEL_REQUIRED_MESSAGE =
  'Indiquez le poids réel de chaque produit à la coupe avant de passer la commande en « Prête ».';

export function formatCommandeStatutUpdateError(err) {
  const rawError = err?.data?.error;
  const code =
    err?.code ||
    err?.data?.code ||
    (typeof rawError === 'string' ? rawError : rawError?.code);

  if (code === 'POIDS_COMPLEMENT_PENDING') {
    return err?.data?.message || POIDS_COMPLEMENT_PENDING_MESSAGE;
  }

  if (code === 'POIDS_REEL_REQUIRED' || code === 'POIDS_REEL_INCOMPLET') {
    return (
      err?.data?.message ||
      err?.message ||
      POIDS_REEL_REQUIRED_MESSAGE
    );
  }

  if (code === 'TRANSITION_NON_AUTORISEE') {
    return err?.data?.message || 'Cette transition de statut n’est pas autorisée.';
  }

  if (code === 'PRICE_LOCKED_ONLINE_PAID') {
    return (
      err?.data?.message ||
      'Cette commande est déjà encaissée en ligne ; le montant ne peut pas être modifié de cette façon.'
    );
  }

  const apiMessage =
    err?.data?.message ||
    (typeof err?.data?.error === 'string' ? err.data.error : null) ||
    err?.message;

  if (apiMessage && !/^Erreur \d{3}$/.test(apiMessage)) {
    return apiMessage;
  }

  return 'Erreur lors de la mise à jour du statut';
}

export { POIDS_REEL_REQUIRED_MESSAGE };
